import * as React from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import { genURL } from "../../_getjson";
import CustomDataGrid from "../../Components/CustomDataGrid/CustomDataGrid";
import CustomBackdrop from "../../Components/CustomBackdrop/Barckdrop";
import CustomInput from "../../Components/CustomInput/CustomInput";
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  blackColor,
  defaultFont,
  grayColor,
} from "../../assets/jss/psstyle/psacount";
const columns = [
  { field: "id", headerName: "id", width: 40 },
  {
    field: "code",
    headerName: "รหัส",
    width: 150,
    editable: false,
  },
  {
    field: "nameTH",
    headerName: "ชื่อ",
    width: 400,
    editable: false,
  },
  {
    field: "rate",
    headerName: "อัตรา",
    width: 50,
    editable: false,
    flex: 1,
  },
];

export default function Incometype(props) {
  const [openbackdrop, setopenbackdrop] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [Inputtext, setInputtext] = React.useState("");

  React.useEffect(() => {
    loadData("all");
    return () => {};
  }, []);
  const loadData = async (val) => {
    setopenbackdrop(true);
    let url = "";
    if (val === "all") {
      url = "CSINCOMETYPE/Search?top=300";
    } else {
      url = `CSINCOMETYPE/Search?top=100&type=${val}&text=${Inputtext}`;
    }
    await console.log("elementzzzzzzzzzzz", genURL(url));
    let rs = await axios.get(genURL(url), { timeout: 12000 });
    let element = [];
    // await console.log("elementzzzzzzzzzzz rs.data.length", rs);
    if (rs.data.length > 0) {
      // console.log("rs", rs.data);

      for (let index = 0; index < rs.data.length; index++) {
        element.push({
          id: Number(index) + 1,
          code: rs.data[index].CODE,
          nameTH: rs.data[index].MYNAMETH,
          rate: rs.data[index].WTAXRATE,
        });
      }

      // await setusedata(element)
      await setRows(element);
    } else {
      await setRows([]);
    }
    await setopenbackdrop(false);
  };

  const resData = (e) => {
    console.log("resData resData", e);
  };
  const removeresData = (e) => {
    console.log("resData removeresData", e);
  };
  const selcetRow = (e) => {
    props.Dataselect(e);
    // console.log("selcetRow", e)
  };
  const resinput = (e) => {
    setInputtext(e);
  };
  const keyDown = (e) => {
    console.log(e);
    if (e === "Enter") {
      loadData("like");
    }
  };
  return (
    <Box sx={{ height: 500, width: "100%" }}>
      <Stack direction="row" spacing={0} mt={1} mb={1}>
        <CustomInput
          label={"คำค้น"}
          resData={(e) => resinput(e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
        />

        <Button
          variant="outlined"
          startIcon={<SearchRoundedIcon />}
          sx={{
            pt: -5,
            height: "32px",
            mt: 1.4,
            borderColor: grayColor[11],
            color: blackColor[0],
            fontFamily: defaultFont,
          }}
          onClick={(e) => loadData("like")}
        >
          ค้นหา
        </Button>
      </Stack>

      {rows.length > 0 ? (
        <CustomDataGrid
          datacolumns={columns}
          datarows={rows}
          rowHeight={38}
          Dataintable={(e) => resData(e)}
          Dataintableremove={(e) => removeresData(e)}
          startRow={1}
          option={[{ add: false, del: false, select: true }]}
          checkboxSelection
          Dataselect={(e) => selcetRow(e)}
          RowsModelChange={(_) => console.log("RowsModelChange")}
        />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} textAlign={"center"}>
            ไม่พบข้อมูล
          </Grid>
        </Grid>
      )}
      <CustomBackdrop open={openbackdrop} />
    </Box>
  );
}
